import { configureRequestParams, getErrorMessage } from '@/utils/helpers'

import axios from './instance'

/**
 * Gets the students for an entity
 * @param {import('@/utils/helpers').RequestParams} payload - The request parameters including sorting, pagination, searchTerm
 * */
export const getStudents = async (payload) => {
  const { entityId, sorting, pagination, searchTerm, filters } = payload

  const combinedFilters = {
    ...filters,
    expand: ['user', 'student_certificates', 'student_certificates.certificate'].join(','),
    omit: [
      'student_certificates.certificate.course_requirements',
      'student_certificates.certificate.proficiency_questions',
    ].join(','),
  }

  const params = configureRequestParams(sorting, pagination, searchTerm, combinedFilters)

  try {
    return await axios.get(`/entities/${entityId}/students/${params}`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
